(() => {
  'use strict';
  
  // Start - Image Loading
  const SELECTOR = '.img-wrap > img.lazy-img';
  const wired = new WeakSet();

  function wireImage(img) {
    if (!img || wired.has(img)) return;
    const wrap = img.closest('.img-wrap');
    if (!wrap) return;

    wired.add(img);

    function markLoaded() {
      wrap.classList.remove('loading', 'error');
      wrap.classList.add('loaded');
      wrap.setAttribute('aria-busy', 'false');
    }
    function markError() {
      wrap.classList.remove('loading', 'loaded');
      wrap.classList.add('error');
      wrap.setAttribute('aria-busy', 'false');
    }
    function markLoading() {
      wrap.classList.remove('loaded', 'error');
      wrap.classList.add('loading');
      wrap.setAttribute('aria-busy', 'true');
    }

    const onLoad = () => markLoaded();
    const onError = () => markError();

    img.addEventListener('load', onLoad);
    img.addEventListener('error', onError);

    const attrObserver = new MutationObserver((mutations) => {
      for (const m of mutations) {
        if (m.type === 'attributes' && (m.attributeName === 'src' || m.attributeName === 'srcset')) {
          if (!img.complete) markLoading();
        }
      }
    });
    attrObserver.observe(img, { attributes: true, attributeFilter: ['src', 'srcset'] });

    if (img.complete) {
      img.naturalWidth ? markLoaded() : markError();
    } else {
      markLoading();
    }

    img.__ajaxImgCleanup__ = () => {
      img.removeEventListener('load', onLoad);
      img.removeEventListener('error', onError);

      attrObserver.disconnect();
      wired.delete(img);

      delete img.__ajaxImgCleanup__;
    };
  }

  function wireInTree(root) {
    if (!(root instanceof Element)) return;

    if (root.matches && root.matches(SELECTOR)) wireImage(root);

    root.querySelectorAll?.(SELECTOR).forEach(wireImage);
  }

  document.querySelectorAll(SELECTOR).forEach(wireImage);

  const domObserver = new MutationObserver((mutations) => {
    for (const m of mutations) {
      m.addedNodes.forEach(wireInTree);

      m.removedNodes.forEach((node) => {
        if (!(node instanceof Element)) return;

        if (node.matches?.(SELECTOR)) node.__ajaxImgCleanup__?.();

        node.querySelectorAll?.(SELECTOR).forEach((img) => img.__ajaxImgCleanup__?.());
      });
    }
  });

  domObserver.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  window.teardownAjaxImageWatcher = () => {
    domObserver.disconnect();
    document.querySelectorAll(SELECTOR).forEach((img) => img.__ajaxImgCleanup__?.());
  };
  // End - Image Loading

  /* Start - Disable Right Click & Drag and Drop */
  const prevent = (e) => {
    e.preventDefault();
    e.stopPropagation();
    return false;
  };

  document.addEventListener('contextmenu', prevent, { capture: true });
  document.addEventListener('dragstart', prevent, { capture: true });
  document.addEventListener('dragover', prevent, { capture: true });
  document.addEventListener('drop', prevent, { capture: true });

  const markNotDraggable = () => {
    document.querySelectorAll('img, video, a, [draggable="true"]').forEach(el => {
      el.setAttribute('draggable', 'false');
    });
  };
  markNotDraggable();

  // const mo = new MutationObserver(markNotDraggable);
  // mo.observe(document.documentElement, {
  //   subtree: true,
  //   childList: true,
  //   attributes: true,
  //   attributeFilter: ['draggable']
  // });
  /* End - Disable Right Click & Drag and Drop */

  /* Start - Product Size Guide Button */
  const sizeGuideButton = document.querySelector('.nextdev--product__size-guide-button--cta');
  const sizeGuideModal = document.querySelector('.nextdev--product__size-guide-button__modal');
  const sizeGuideModalCloseButton = sizeGuideModal.querySelector('.nextdev--product__size-guide-button__modal--close');

  sizeGuideButton.addEventListener('click', () => {
    document.body.classList.add('overflow-hidden');
    sizeGuideModal.classList.remove('hide');
  });

  sizeGuideModalCloseButton.addEventListener('click', () => {
    sizeGuideModal.classList.add('hide');
    document.body.classList.remove('overflow-hidden');
  });

  sizeGuideModal.addEventListener('click', (e) => {
    if (e.target == sizeGuideModal) {
      sizeGuideModal.classList.add('hide');
      document.body.classList.remove('overflow-hidden');
    }
  });
  /* End - Product Size Guide Button */
})();
